<!-- /**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */ -->
<template>
  <div>
    <v-row align="center" justify="center">
      <v-col md="6" cols="12">
        <validation-provider
          v-slot="{ errors, invalid, touched }"
          name="Nombre"
          rules="required|max:40"
        >
          <v-text-field
            :counter="40"
            maxlength="40"
            v-model.trim="model.name"
            label="Nombre*"
            clearable
            required
            outlined
            autocomplete="off"
            :error-messages="errors"
            dense
            clear-icon="mdi-eraser"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col md="6" cols="12">
        <validation-provider
          v-slot="{ errors, invalid, touched }"
          name="URL"
          rules="required|max:200"
        >
          <v-text-field
            :counter="200"
            maxlength="200"
            v-model.trim="model.pathService"
            label="URL*"
            clearable
            outlined
            required
            autocomplete="off"
            :error-messages="errors"
            dense
            clear-icon="mdi-eraser"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </validation-provider>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col md="6" cols="12">
        <validation-provider
          v-slot="{ errors, invalid, touched }"
          name="Clave de acceso"
          rules="required|max:20"
        >
          <v-text-field
            :counter="20"
            maxlength="20"
            v-model.trim="model.accessKey"
            label="Clave de acceso*"
            outlined
            clearable
            required
            autocomplete="off"
            :error-messages="errors"
            dense
            clear-icon="mdi-eraser"
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col md="6" cols="12">
        <validation-provider
          v-slot="{ errors, invalid, touched }"
          name="Método de envío"
          rules="required"
        >
          <v-autocomplete
            dense
            clearable
            required
            auto-select-first
            autocomplete="off"
            :error-messages="errors"
            :items="$cnst.HTTPMETHOD_LIST"
            v-model.trim="model.httpMethod"
            label="Método de envío*"
            outlined
            clear-icon="mdi-eraser"
            no-data-text="Sin resultados disponibles."
          >
            <v-icon slot="append" :color="touched && invalid ? 'error' : ''">
              {{ touched && invalid ? "mdi-alert" : "" }}
            </v-icon>
          </v-autocomplete>
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    model: Object,
  },
  data() {
    return {};
  },
};
</script>
